import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

import { PASSWORD_RULES } from '../../utils/password-rule'

const PasswordChecklist = ({ password }) => (
  <Box>
    {PASSWORD_RULES.map(rule => {
      const ok = rule.test(password || '')

      return (
        <Box key={rule.key} display="flex" alignItems="center" gap={1}>
          {ok ? (
            <CheckIcon fontSize="small" color="success" />
          ) : (
            <CloseIcon fontSize="small" color="disabled" />
          )}
          <Typography
            variant="body2"
            color={ok ? 'text.primary' : 'text.secondary'}
          >
            {rule.label}
          </Typography>
        </Box>
      )
    })}
  </Box>
)

PasswordChecklist.propTypes = {
  password: PropTypes.string
}

export default PasswordChecklist
